module.exports = __webpack_public_path__ + "static/media/dsc_0489.3823cd7e.jpg";